import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

import { AuthService, SettingsService } from '@app/core/auth';
import { ClientService } from '@app/core/client/services/client.service';
import { LocationService } from '@app/core/locations/services/location.service';
import { CategoryService } from '@app/core/products/services/category.service';
import { RfqService } from '@app/core/quotes';
import { StaffService } from '@app/core/staff';
import { ExportRfqService } from '@app/shared/services/export-rfq.service';
import { UIStateService } from '@app/shared/services/ui-state.service';

import { NdPopupFormComponent } from '../nd-popup-form/nd-popup-form.component';

@Component({
  selector: 'cnc-nd-product-page',
  templateUrl: './nd-product-page.component.html',
  styleUrls: ['./nd-product-page.component.scss'],
})
export class NdProductPageComponent implements OnInit {
  constructor(
    public authService :AuthService,
    public rfqService :RfqService,
    private modalSvc :NgbModal,
    public pcatService :CategoryService,
    public exportRfq :ExportRfqService,
    public staffService :StaffService,
    public clientSvc :ClientService,
    private uiStateSvc :UIStateService,
    public settingsSvc :SettingsService,
    private cd :ChangeDetectorRef,
  ) {}

  view :string = 'list';
  activePipeline :any = false;
  newDesign :any;

  ngOnInit() {
    const stateView = this.uiStateSvc.getState('product-designs');
    if (stateView && stateView.view) {
      this.view = stateView.view;
      this.cd.detectChanges();
    }
  }

  viewList() {
    this.view = 'list';
    this.uiStateSvc.setState('product-designs', { view: 'list' });
  }

  setActivePipeline(pipeline :any) {
    // console.log(pipeline);
    this.activePipeline = pipeline;
  }

  viewPipelines() {
    this.view = 'pipeline';
    this.uiStateSvc.setState('product-designs', { view: 'pipeline' });
  }

  createNewDesign() {
    const modalRef = this.modalSvc.open(NdPopupFormComponent, {
      size: 'lg',
    });
    modalRef.componentInstance.activePipeline = this.activePipeline;
    modalRef.result.then(
      (resp :any) => {
        if (resp && resp.id) {
          // this.viewList();
          this.newDesign = resp;
          this.cd.detectChanges();
        }
      },
      (_) => {},
    );
  }
}
